import React, { useEffect, useState } from "react";
import api from "../api/api";
import ProgramCard from "../components/ProgramCard";
import "../styles/programs.css";

const Programs = () => {
  const [programs, setPrograms] = useState([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  /* ---------------- FETCH PROGRAMS ---------------- */
  useEffect(() => {
    const fetchPrograms = async () => {
      try {
        const res = await api.get("programs/");
        setPrograms(res.data || []);
      } catch (err) {
        console.error("Failed to fetch programs:", err);
        setError("Failed to load programs. Please try again later.");
      } finally {
        setLoading(false);
      }
    };
    fetchPrograms();
  }, []);

  /* ---------------- FILTER PROGRAMS (Flexible / Case-Insensitive) ---------------- */
  const filteredPrograms =
    filter === "all"
      ? programs
      : programs.filter(
          (p) =>
            p.category &&
            p.category.toLowerCase().includes(filter.toLowerCase())
        );

  /* ---------------- LOADING STATE ---------------- */
  if (loading)
    return (
      <div className="app">
        <div className="section-wrapper">
          <p className="program-loading">Loading programs...</p>
        </div>
      </div>
    );

  /* ---------------- ERROR STATE ---------------- */
  if (error)
    return (
      <div className="app">
        <div className="section-wrapper">
          <p className="program-error">{error}</p>
        </div>
      </div>
    );

  /* ---------------- MAIN PAGE ---------------- */
  return (
    <div className="app">
      <div className="section-wrapper">

        {/* Page Title */}
        <h1 className="programs-title">Our Programs</h1>

        {/* Filter Dropdown */}
        <div className="program-filter">
          <select
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className="program-filter-select"
          >
            <option value="all">All Programs</option>
            <option value="pre_primary">Pre-Primary School</option>
            <option value="learning_hub">Learning Hub</option>
            <option value="health">Health Camps</option>
          </select>
        </div>

        {/* Empty State */}
        {filteredPrograms.length === 0 && (
          <p className="program-empty">No programs found</p>
        )}

        {/* Programs Grid */}
        <div className="programs-grid">
          {filteredPrograms.map((program) => (
            <ProgramCard key={program.id} program={program} />
          ))}
        </div>

      </div>
    </div>
  );
};

export default Programs;